import getWatchedProgress from "./getWatchedProgress";
import getWatchedSeconds from "./getWatchedSeconds";

// Video watched per day, on the same basis as the per-video Watched column:
// seconds of the video covered (getWatchedProgress, capped at its length),
// not wall-clock playtime. QA 10-15: the week/month totals summed wall-clock
// time while each row showed content covered, so a video played at 1.5x
// made the rows add up to more than the totals (17m 23s vs 13m 42s).
//
// watchedRanges have no dates, so a video's covered seconds are split across
// the days it was played in proportion to that day's playtime
// (dailyBreakdown). Each video's days always add up to exactly its Watched
// value. An entry with no playtime days falls back to its lastWatched day.

const dayOf = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  return isNaN(d) ? null : d.toISOString().split("T")[0];
};

export const watchedByDay = (entry, video) => {
  const total = getWatchedSeconds(getWatchedProgress(entry), video);
  if (!(total > 0)) return {};

  const days = Object.entries(entry?.dailyBreakdown || {})
    .map(([day, secs]) => [day, Number(secs) || 0])
    .filter(([, secs]) => secs > 0);
  const played = days.reduce((sum, [, secs]) => sum + secs, 0);
  if (played > 0) {
    return Object.fromEntries(
      days.map(([day, secs]) => [day, (total * secs) / played]),
    );
  }

  const last = dayOf(entry?.lastWatched);
  return last ? {[last]: total} : {};
};

// All videos combined: {"YYYY-MM-DD": seconds}. getVideo(id) returns the
// catalog entry (for the length cap) or undefined.
export const watchedSecondsByDay = (watchHistory, getVideo = () => null) => {
  const out = {};
  Object.entries(watchHistory || {}).forEach(([id, entry]) => {
    Object.entries(watchedByDay(entry, getVideo(id))).forEach(([day, secs]) => {
      out[day] = (out[day] || 0) + secs;
    });
  });
  return out;
};
